module.exports = __webpack_public_path__ + "static/media/P1000867-1.468fcbf4.jpg";